<div class="container-fluid row_banner">
  <app-header></app-header>
  <div class="row">
    <div class="container pt-5">
      <div
        class="row row py-3 mt-2 justify-content-center"
        style="align-content: center"
        id="row_faqs"
      >
        <div
          class="col-lg-7 col-md-9 mb-4"
          style="align-content: center"
          id="footergrammartext"
        >
          <h1
            class="w-100"
            class="text-center"
            style="font-weight: 700; font-size: 40px"
          >
            Help Center
          </h1>
          <span
            class="w-100 d-inline-block main_text justify-content-center"
            class="text-center"
            style="
              font-size: 18px;
              font-weight: 600;
              line-height: 28px;
              text-align: center;
              display: block;
            "
          >
            Grammarin.com is a pedagogical rostrum where learner and teachers
            get benefit from hundreds of professional
            <br />writers to assist them with their writing assignments.
          </span>
        </div>
        <div class="container my-2">
          <div class="row justify-content-center">
            <div class="col-sm-8 faq-container">
              <div class="row v-pills-tab-list" id="v-pills-tab-list">
                <div class="col-md-6" id="row_faqs">
                  <div
                    class="nav flex-column nav-pills"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <a
                      class="nav-link nav-pills card active"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      id="v-pills-first-tab"
                      aria-controls="q5"
                      aria-expanded="true"
                      class="mb-0"
                      data-toggle="collapse"
                      href="#q5"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >What is Grammarin.com?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse show"
                        id="q5"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          <a href="/" class="aTag"> Grammarin.com </a> is a
                          pedagogical rostrum where learners and teachers
                          benefit from hundreds of professional writers to
                          assist them with their writing assignments.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q6"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Why choose Grammarin.com?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q6"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          What makes students trust our services? Unprecedented
                          professionalism: We brag a core of executive writers
                          who have passed four stages of the hiring process to
                          certify a high level of competence and credibility.
                          Authentic, high-quality work: We assure that the
                          completed project will be original and of the highest
                          quality. The articles come with zero grammatical
                          errors and fully address the subject area. Client
                          secrecy: We also provide complete privacy to our
                          consumers. We assure you that no third party will ever
                          have access to customers’ private information.
                          Besides, we only need an email to verify.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q7"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >How does Grammarin.com work?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q7"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Grammarin.com automatically checks your punctuation,
                          grammatical errors, spelling errors, word choices, and
                          style mistakes in your writing. It’s easy to use: Copy
                          and paste any English text into Grammarin.com Editor.
                          Furthermore, our website will help you to write
                          correctly. Grammarin.com algorithms flag potential
                          issues in the text and suggest context-specific
                          corrections for grammar checking, style, spelling,
                          wordiness, punctuation, and even plagiarism. Grammarin
                          explains the reasoning behind each correction, so you
                          can make an informed decision about whether, and how,
                          to correct an issue.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #eaeaea;
                        margin: 8px 0;
                        padding: 10px 14px;
                        border-radius: 10px;
                        background: #fff;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q8"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Who uses Grammarin.com?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q8"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Millions of writers worldwide trust Grammarin.com
                          because Grammarin helps the students to achieve their
                          academic goals and improve their writing in essays,
                          reports, theses, dissertations, and college entrance
                          applications. Professionals uses Grammarin.com to
                          provide expert help and instant feedback on the
                          accuracy, impact, and credibility of their English
                          writing in a variety of fields, such as law,
                          healthcare, academia, marketing, engineering, and
                          journalism. Grammarin.com can be an equally powerful
                          tool for job seekers, foreign students and English
                          language learners, and non-native English-speaking
                          professionals.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q9"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Do I need to register to be able to use
                              Grammarin.com?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q9"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Grammarin.com prefer their users to register and enter
                          their personal information to get benefit from
                          services. After registration, we can also send updates
                          to your email.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #eaeaea;
                        margin: 8px 0;
                        padding: 10px 14px;
                        border-radius: 10px;
                        background: #fff;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q10"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Do you save any of the content after
                              checking?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q10"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          We at Grammarin.com give colossal value to your
                          privacy that is why we don’t save or store your
                          content in our database. The whole process is entirely
                          automatic using a unique algorithm that carefully
                          checks the content.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #eaeaea;
                        margin: 8px 0;
                        padding: 10px 14px;
                        border-radius: 10px;
                        background: #fff;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q12"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >How can I erase my personal data from
                              grammarin.com?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q12"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          At Grammarin.com, you can easily erase your personal
                          information at any time you like, all you have to do
                          is to email us at support&#64;grammarin.com. However,
                          for security reasons, all premium users will be asked
                          to terminate their subscriptions first before they can
                          delete their account with us.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #eaeaea;
                        margin: 8px 0;
                        padding: 10px 14px;
                        border-radius: 10px;
                        background: #fff;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q11"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Will you sell or share my personal information to
                              a third party?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q11"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          The Grammain.com will not sell or trade your personal
                          information to a third party. However, we may share it
                          to a service provider that work with us in fulfilling
                          our business operations.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q13"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >How secure is my work?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q13"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Grammarin.com never keeps your work. We run thousands
                          of analysis requests every day, the data is sent to
                          our servers to be processed but it is never stored on
                          our servers. We give you our word as fellow writers.
                          Your documents are created and uploaded to your
                          account, but you are the only one who has access to
                          them. The data is also encrypted.
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="nav flex-column nav-pills"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q16"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >How do I delete my account?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q16"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          We're sad to see you go. Here's how to delete your
                          account: Log in to your account. Click on your
                          username in the top right-hand corner of the screen.
                          Click on 'Delete my account'. Confirm the deletion by
                          clicking on 'Delete my account'.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q15"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >What is the maximum word limit Grammarin can
                              check?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q15"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          The word limit is no maximum, however, requests over
                          150,000 characters (about 30,000 words) are broken
                          down into sections. This is done by chapter if the
                          document includes chapter headings, or into chunks of
                          100,000 characters otherwise. Grammarin works best
                          when looking at fewer than 10,000 words at a time. If
                          you want any additional services you can check our
                          <a class="aTag" href="/pricing"> PRO </a>version.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q17"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >How do I use the Plagiarism Check?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q17"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Plagiarism is a foremost concern for many people,
                          especially in academic writing. The plagiarism checks
                          performed by Grammarin.com will check your work
                          against over a billion web-pages and articles to make
                          sure that you have correctly cited any unoriginal
                          content. It is easy for unoriginal content to slip
                          into your work, and the consequences can be
                          disastrous. To avoid these issues, it’s essential to
                          regularly
                          <a class="aTag" href="/plagiarism-checker">
                            check plagiarism
                          </a>
                          to ensure the integrity of your work.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q20"
                    >
                      <h3 style="display: flex">
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >When I submit a paper to your site, will it be
                              detected by a plagiarism detection service when my
                              teacher checks it?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q20"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Grammarin.com does not distribute your papers to any
                          plagiarism detection services, nor does our own
                          plagiarism detection rely on past submissions.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #eaeaea;
                        margin: 8px 0;
                        padding: 10px 14px;
                        border-radius: 10px;
                        background: #fff;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q21"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Does Grammarin.com correct errors
                              automatically?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q21"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Grammarin.com is to assist users in correcting their
                          errors so that they learn from the process. Unlike
                          other grammar checking software applications which
                          correct mistakes without user involvement,
                          Grammarin.com flags errors and suggests how to rectify
                          the problem. In this way, the user is responsible for
                          making the necessary corrections and will likely learn
                          from this involvement.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q19"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Grammarin.com also check languages other than
                              English?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q19"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Grammarin.com can only check texts that have been
                          written in English.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q25"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >Is this grammar checker safe to use?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right"></i>
                            <i class="ml-2 fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q25"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          Unless you’re writing something legally or
                          commercially sensitive, then yes. A good grammar
                          checker won’t monitor your content. If your document
                          is legally sensitive, a <a class="aTag" href="/grammar-checker"> grammar checker </a> is unlikely to
                          help you.
                        </div>
                      </div>
                    </a>
                    <a
                      class="nav-link nav-pills"
                      style="
                        border: 1px solid #e3e3f0;
                        margin: 8px 0;
                        padding: 10px 14px;
                        background: #fff;
                        border-radius: 10px;
                      "
                      class="card active"
                      id="v-pills-2nd-tab"
                      aria-controls="q5"
                      aria-expanded="false"
                      class="mb-0 collapsed"
                      data-toggle="collapse"
                      href="#q22"
                    >
                      <h3>
                        <div
                          class="d-flex"
                          style="display: flex; justify-content: space-between"
                        >
                          <div>
                            <span class="card-header faqHeading"
                              >What kinds of errors are identified?</span
                            >
                          </div>
                          <div>
                            <i class="ml-2 fas fa-chevron-right ml-2"></i>
                            <i class="ml-2 fas fa-chevron-down ml-2"></i>
                          </div>
                        </div>
                      </h3>
                      <div
                        aria-labelledby="q5"
                        class="collapse"
                        id="q22"
                        role="tabpanel"
                        data-parent="#v-pills-tab-list"
                      >
                        <div class="card-body faqPar">
                          An important thing to configure is, that errors are
                          the results of a number of combinations and factors.
                          Since Grammarin.com identifies errors based on
                          pre-determined rules resulting from errors found in
                          previous submissions, it cannot flag a one-time error.
                          For a rule to be created, an error must have been made
                          more than once and by more than one user. Also,
                          Grammarin.com cannot evaluate the semantic
                          acceptability of submitted texts. If a sentence comes
                          across as bizarre and completely incomprehensible, but
                          the syntax (grammar) is fine, Grammarin.com will not
                          suggest any corrections. Take the following sentence:
                          The bananas eat the gorilla Although very
                          sophisticated, Grammarin.com is incapable of
                          understanding what is written. As such, it will not
                          flag anything in this sentence. However, if one
                          writes, “the bananas eats the gorilla”, Grammarin.com
                          will identify the grammatical error on the verb. Note
                          also that if you invent a sentence that is unlikely to
                          occur, e.g. I knead ewe, it probably won't be caught
                          since we are too busy writing rules for mistakes
                          people actually make!
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div></div>
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <svg
    id="i-chevron-top"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="15"
    height="32"
    fill="none"
    stroke="currentcolor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="3"
  >
    <path d="M30 20 L16 8 2 20" />
  </svg>
</a>
<app-footer></app-footer>
